import { useEffect, useState, useRef } from "react";
import * as SubMenuService from "../../../Services/Masters/Menu/SubMenuService"; 
import { FaToggleOn, FaToggleOff, FaPen, FaExclamationCircle } from "react-icons/fa";
import * as FaIcons from 'react-icons/fa';
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import MultiSelect from 'multiselect-react-dropdown';

const SubMenuComponent = (props) =>{
    const { register, handleSubmit, formState: { errors }, reset, } = useForm();
    const {selectedMenuDet, handleSubMenuModalClose} = props

    const [subMenuList, setSubMenuList] = useState([]);
    const [selectedSubMenu, setSelectedSubMenu] = useState({});
    const [currentSubMenuId, setCurrentSubMenuId] = useState(null);
    const [roleList, setRoleList] = useState([]);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const multiSelectRef = useRef();

    const getSubMenuList_ByMenuId = (Menu_Id) =>{
        SubMenuService.GetSubMenuList_ByMenuId(Menu_Id)
        .then(({data}) =>{
            if(data.IsSuccess){
              setSubMenuList(data.Data);
            }
          });
    }

    useEffect(() =>{
        getSubMenuList_ByMenuId(selectedMenuDet.Menu_Id)
        getMappedUnMappedMenu_RoleList(selectedMenuDet.Menu_Id);
    }, [])

    const onSubmit = (data) =>{
      if (selectedSubMenu?.SubMenu_Id) {
          data.Menu_Id = selectedMenuDet.Menu_Id
          data.SubMenu_Id = selectedSubMenu.SubMenu_Id
          data.Sequence_No = data.Sequence_No === "" ? null : Number(data.Sequence_No);

          const formattedData = {
            "MenuMappingDet" : roleList,
            "SubMenuDet": data
          }

          SubMenuService.UpdateSubMenu(formattedData)
            .then(({ data }) => {
              if (data.IsSuccess) {
                  getSubMenuList_ByMenuId(selectedMenuDet.Menu_Id)
                  toast.success("SubMenu updated successfully!");
                  handleCancelUpdate()
              } else {
                toast.error("Something went wrong during update.");
              }
            })
            .catch(() => toast.error("Something went wrong during update."))
            .finally(() => { });
        } else {
          data.Menu_Id = selectedMenuDet.Menu_Id
          data.Sequence_No = data.Sequence_No === "" ? null : Number(data.Sequence_No);

          const formattedData = {
            "MenuMappingDet" : roleList,
            "SubMenuDet": data
          }

          SubMenuService.CreateNewSubMenu(formattedData)
            .then(({ data }) => {
              if (data.IsSuccess) {
                  getSubMenuList_ByMenuId(selectedMenuDet.Menu_Id)
                  toast.success("SubMenu saved successfully!");
                  handleCancelUpdate()
              } else {
                toast.error(data.ResponseMessage);
              }
            })
            .catch(() => toast.error("Something went wrong during creation."))
            .finally(() => { });
        }
    }

    const handleViewSubMenuDetailById = (rec) => {
        reset();
        const selectedItem = subMenuList.find(item => item.SubMenu_Id === rec.SubMenu_Id);
        if(selectedItem != null){
            setSelectedSubMenu(selectedItem);
            setCurrentSubMenuId(selectedItem.SubMenu_Id);
            getMappedUnMappedMenu_RoleList(selectedMenuDet.Menu_Id, selectedItem.SubMenu_Id)
        }
        else{
            setSelectedSubMenu({});
        }
      };

    const handleActivateDeActivateSubMenu = (rec) =>{
        SubMenuService.ActivateDeActivateSubMenu(rec.SubMenu_Id, !rec.IsActive).then(data => {
          if (data.data.IsSuccess) {
            const message = rec.IsActive ? "SubMenu DeActivated Successfully" : "SubMenu Activated Successfully";
            toast.success(message);
            getSubMenuList_ByMenuId(selectedMenuDet.Menu_Id)
          } else {
            toast.error("Something went wrong");
          }
        }).catch(error => {
          toast.error("Something went wrong");
        })
    }

    const handleSubMenuMappingDelete = (Role_Id) =>{
      const updatedList = roleList.map(item =>
        item.Role_Id === Role_Id
          ? { ...item, IsDeleted: true, IsSelected: false, SubMenu_Id: currentSubMenuId }
          : item
      );
      setRoleList(updatedList);
    }
  
    const handleSubMenuMappingInsert = (Role_Id) =>{
      const updatedList = roleList.map(item =>
        item.Role_Id === Role_Id
          ? { ...item, IsSelected: true, IsDeleted: false, SubMenu_Id: currentSubMenuId }
          : item
      );
      setRoleList(updatedList);
    }

    const getMappedUnMappedMenu_RoleList = (menuId, subMenuId=0) =>{
        SubMenuService.GetMappedUnMappedSubMenu_RoleList(menuId, subMenuId)
        .then(({data}) =>{
          if(data.IsSuccess){
            setRoleList(data.Data);
          }
        });
      }

    const handleCancelUpdate = () =>{
      reset();
      setSelectedSubMenu({})
      multiSelectRef.current.resetSelectedValues();
    }

    return (
        <>
        <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg modal-dialog-centered custom-modal" style={{width: "90%" }} role="document">
                <div className="modal-content mb-0 p-0" style={{ maxHeight: '500px' }}>
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title"><span>Edit Menu:</span> {selectedMenuDet.Menu_Name}</h5>
                      <button type="button" className="btn-close" onClick={() => handleSubMenuModalClose()}></button>
                    </div>
                    <div className="modal-body p-1" style={{ overflowY: 'auto' }}>
                        <div className="container mb-0" style={{ fontSize: "13px" }}>
                          <div className="row" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                              <div className="container mb-0" style={{ fontSize: "13px" }}>
                              
                                <div className="row">
                                  <div className="col-md-4 mb-2">
                                    <label className="fw-bold required mb-0-5">Sub Menu</label>
                                    <input type="text" className="form-control" placeholder="Enter SubMenu" {...register("SubMenu_Name", { required: "SubMenu is required" })} defaultValue={selectedSubMenu?.SubMenu_Name || ""} />
                                    {errors.SubMenu_Name && <p className="text-danger required_error">{errors.SubMenu_Name.message}</p>}
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <label className="fw-bold required mb-0-5">Description</label>
                                    <input type="text" className="form-control" placeholder="Enter Description" {...register("Description", { required: "Description is required" })} defaultValue={selectedSubMenu?.Description || ""} />
                                    {errors.Description && <p className="text-danger required_error">{errors.Description.message}</p>}
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <label className="fw-bold required mb-0-5">Url</label>
                                    <input type="text" className="form-control" placeholder="Enter Url" {...register("URL", { required: "Url is required" })} defaultValue={selectedSubMenu?.URL || ""} />
                                    {errors.URL && <p className="text-danger required_error">{errors.URL.message}</p>}
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <label className="fw-bold required mb-0-5">
                                      Icon
                                      <span 
                                        className="ms-2 position-relative" 
                                        style={{ cursor: 'pointer' }}
                                        onMouseEnter={() => setTooltipVisible(true)}
                                        onMouseLeave={() => setTooltipVisible(false)}
                                      >
                                        <FaExclamationCircle 
                                          size={14} 
                                          color="#6c757d"
                                          onClick={() => window.open('https://react-icons.github.io/react-icons/icons/fa/', '_blank')}
                                        />
                                        {tooltipVisible && (
                                          <div 
                                            className="position-absolute bg-dark text-white p-2 rounded"
                                            style={{
                                              zIndex: 1000,
                                              width: '200px',
                                              fontSize: '12px',
                                              top: '20px',
                                              left: '0'
                                            }}
                                          >
                                            Kindly choose icon from the 
                                            <a 
                                              href="https://react-icons.github.io/react-icons/icons/fa/" 
                                              target="_blank" 
                                              rel="noopener noreferrer"
                                              className="text-info ms-1"
                                            >
                                              link
                                            </a> 
                                            &nbsp;and type in the name
                                          </div>
                                        )}
                                      </span>
                                    </label>
                                    <input type="text" className="form-control" placeholder="Eg: FaCircle" {...register("Icon", { required: "Icon is required", validate: (value) => value in FaIcons || "Icon not found in react-icons/fa" })} defaultValue={selectedSubMenu?.Icon || ""} />
                                    {errors.Icon && <p className="text-danger required_error">{errors.Icon.message}</p>}
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <label className="fw-bold mb-0-5">Sequence_No</label>
                                    <input type="number" className="form-control" placeholder="Enter Sequence_No" {...register("Sequence_No")} defaultValue={selectedSubMenu?.Sequence_No || null} />
                                  </div>
                                  <div className="col-md-4 mb-2">
                                    <label className="fw-bold mb-0-5">Role Access</label>
                                      <MultiSelect
                                        ref={multiSelectRef}
                                        options={roleList}
                                        selectedValues={roleList.filter(role => role.IsSelected)}
                                        displayValue="Role_Name"
                                        onSelect={(selectedList, selectedItem) => handleSubMenuMappingInsert(selectedItem.Role_Id)}
                                        onRemove={(selectedList, removedItem) => handleSubMenuMappingDelete(removedItem.Role_Id)}
                                        placeholder="Select Roles"
                                      />
                                  </div>
                                </div>
                                
                              </div>
                              <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                              {/* {selectedSubMenu?.SubMenu_Id && <button type="button" className="btn btn-danger" onClick={handleCancelUpdate}>Cancel</button>} */}
                              <button type="button" className="btn btn-danger" onClick={handleCancelUpdate}>Cancel</button>
                              <button type="submit" className="btn btn-primary">{selectedSubMenu?.SubMenu_Id ? "Update Sub Menu" : "Add Sub Menu"}</button>
                              </div>
                            </form>
                          </div>
                          <hr></hr>
                          <div className="row" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                              <div>
                                  <div className="table-responsive" >
                                  <table className="table table-bordered custom-table" >
                                      <thead>
                                      <tr>
                                          <th> SubMenu</th>
                                          <th> Description</th>
                                          <th> Url </th>
                                          <th> Sequence_No </th>
                                          <th> Icon</th>
                                          <th> Active </th>
                                          <th> Action </th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {
                                          subMenuList.length > 0 ? (
                                          subMenuList.map((rec, index) => (
                                              <tr key={index} >
                                              <td>{rec.SubMenu_Name}</td >
                                              <td>{rec.Description}</td >
                                              <td>{rec.URL}</td >
                                              <td>{rec.Sequence_No}</td >
                                              <td>{rec.Icon}</td >
                                              <td>
                                                  {rec.IsActive ? <FaToggleOn title="Deactivate Menu" onClick={() => handleActivateDeActivateSubMenu(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateSubMenu(rec)} title="Activate Menu" color="red" size={16} />}
                                              </td>
                                              <td>
                                                  <div className="flex items-center space-x-7">
                                                  <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewSubMenuDetailById(rec)} title="Edit Menu" />
                                                  {/* <FaBars className="mr-2 cursor-pointer" color={"green"} onClick={() => handleViewSubMenuMappingDetails(rec)} title="Edit Menu Mapping"/> */}
                                                  </div>
                                              </td>
                                              </tr>
                                              ))
                                          ) : (
                                          <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                                          )}
                                      </tbody>
                                  </table>
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                      <button type="button" className="btn btn-danger" onClick={handleSubMenuModalClose}>Close</button>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default SubMenuComponent;